import { Yield } from '../../abacus/interfaces/yield.interface'

export const metricTypeYields: Yield[] = [
  {
    label: 'Name',
    property: 'name'
  },
  {
    label: 'Description',
    property: 'description'
  }
]
